/**
 *  * Rôle : Affiche les catégories général
 * Copyright: © 2021 Remote Monkey S.A.S.U http://remote-monkey.fr
 */
import { Link } from '@reach/router';
import React from 'react';
import H2 from '../../../functional/H2';
const Categories = (props) => {
	const { type, categories, liste, selectCategorie } = props;

	return (
		<div className="bg-gray-100 w-full p-10 text-gray-500 mt-10 md:mt-0">
			<H2>{type === 'coran' ? 'Récitateurs' : 'Catégories'}</H2>

			{/* Liste des catégories */}
			{categories.sort().map((item, index) =>
				item ? (
					<div key={index} className="flex items-start justify-between my-2">
						<Link
							to={`/${type === 'coran' ? 'coran' : 'audios'}?cat=${item.replace(
								/ /g,
								'+'
							)}`}
							key={index}
							onClick={() =>
								selectCategorie(
									item
										.replace(/&rsquo;/g, "'")
										.replace(/&rsquo;/g, "'")
										.replace(/&lsquo;/g, "'")
										.replace(/&rsquo%3B/g, "'")
								)
							}
							className={`text-xs /${
								type === 'coran' ? 'w-full' : 'w-10/12'
							} block hover:text-primary hover:underline animate text-left uppercase`}
						>
							{item.replace(/&rsquo;/g, "'").replace(/&lsquo;/g, "'")}
						</Link>
						{type === 'coran' ? null : (
							<div className="flex justify-end w-2/12 ml-4">
								<span
									style={{ fontSize: '0.55rem' }}
									className="bg-secondary rounded-full text-white flex items-center justify-center w-7 h-7"
								>
									{liste.filter((el) => el.theme === item).length}
								</span>
							</div>
						)}
					</div>
				) : null
			)}
		</div>
	);
};

export default Categories;
